import { put, call } from "redux-saga/effects";
import {
    SAVE_I130_BIOGRAPHICS_SUCCESS, SAVE_I130_BIOGRAPHICS_FAILED,
    UPDATE_I130_BIOGRAPHICS_SUCCESS, UPDATE_I130_BIOGRAPHICS_FAILED,
    GET_I130_BIOGRAPHICS_SUCCESS, GET_I130_BIOGRAPHICS_FAILED,

    SAVE_I130FORMS_SUCCESS, SAVE_I130FORMS_FAILED,
    UPDATE_I130FORMS_SUCCESS, UPDATE_I130FORMS_FAILED,
    GET_I130FORMS_SUCCESS, GET_I130FORMS_FAILED,
    SAVEPDF_I130FORMS_FAILED, SAVEPDF_I130FORMS_SUCCESS,

    SAVE_I130AFORMS_SUCCESS, SAVE_I130AFORMS_FAILED,
    UPDATE_I130AFORMS_SUCCESS, UPDATE_I130AFORMS_FAILED,
    GET_I130AFORMS_SUCCESS, GET_I130AFORMS_FAILED,
    SAVEPDF_I130AFORMS_FAILED, SAVEPDF_I130AFORMS_SUCCESS,

    SAVE_I131FORMS_SUCCESS, SAVE_I131FORMS_FAILED,
    UPDATE_I131FORMS_SUCCESS, UPDATE_I131FORMS_FAILED,
    GET_I131FORMS_SUCCESS, GET_I131FORMS_FAILED,
    SAVEPDF_I131FORMS_FAILED, SAVEPDF_I131FORMS_SUCCESS,

    SAVE_I864FORMS_SUCCESS, SAVE_I864FORMS_FAILED,
    UPDATE_I864FORMS_SUCCESS, UPDATE_I864FORMS_FAILED,
    GET_I864FORMS_SUCCESS, GET_I864FORMS_FAILED,
    SAVEPDF_I864FORMS_FAILED, SAVEPDF_I864FORMS_SUCCESS,

    SAVE_I485FORMS_SUCCESS, SAVE_I485FORMS_FAILED,
    UPDATE_I485FORMS_SUCCESS, UPDATE_I485FORMS_FAILED,
    GET_I485FORMS_SUCCESS, GET_I485FORMS_FAILED,
    SAVEPDF_I485FORMS_FAILED, SAVEPDF_I485FORMS_SUCCESS


} from "../actions/I130Case";
import { I130CasesAPI } from "../../utils/api/I130CasesAPI";
export function* biographicsCreate(request: any) {

    try {
        const result = yield call(I130CasesAPI.biographicsCreate, request.input);
        yield put({
            type: SAVE_I130_BIOGRAPHICS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I130_BIOGRAPHICS_FAILED, payload: e.message });
    }
}

export function* biographicsUpdate(request: any) {

    try {
        const result = yield call(I130CasesAPI.biographicsUpdate, request.input);
        yield put({
            type: UPDATE_I130_BIOGRAPHICS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I130_BIOGRAPHICS_FAILED, payload: e.message });
    }
}

export function* getBiographicsDetails(request: any) {
    try {

        const { data } = yield call(I130CasesAPI.getBiographicsDetails, request);

        yield put({
            type: GET_I130_BIOGRAPHICS_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_I130_BIOGRAPHICS_FAILED, payload: e.message });
    }
}

export function* i130formsCreate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i130formsCreate, request.input);
        yield put({
            type: SAVE_I130FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I130FORMS_FAILED, payload: e.message });
    }
}

export function* i130formsUpdate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i130formsUpdate, request.input);
        yield put({
            type: UPDATE_I130FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I130FORMS_FAILED, payload: e.message });
    }
}

export function* getI130formsDetails(request: any) {
    try {

        const { data } = yield call(I130CasesAPI.getI130formsDetails, request);

        yield put({
            type: GET_I130FORMS_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_I130FORMS_FAILED, payload: e.message });
    }
}

export function* i130FormPdfData(request: any) {

    try {
        const { data } = yield call(I130CasesAPI.i130FormPdfData, request);

        yield put({
            type: SAVEPDF_I130FORMS_SUCCESS,
            payload: data

        });
    } catch (e) {
        yield put({ type: SAVEPDF_I130FORMS_FAILED, payload: e.message });
    }
}

export function* i130AformsCreate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i130AformsCreate, request.input);
        yield put({
            type: SAVE_I130AFORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I130AFORMS_FAILED, payload: e.message });
    }
}

export function* i130AformsUpdate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i130AformsUpdate, request.input);
        yield put({
            type: UPDATE_I130AFORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I130AFORMS_FAILED, payload: e.message });
    }
}

export function* getI130AformsDetails(request: any) {
    try {

        const { data } = yield call(I130CasesAPI.getI130AformsDetails, request);

        yield put({
            type: GET_I130AFORMS_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_I130AFORMS_FAILED, payload: e.message });
    }
}

export function* i130AFormPdfData(request: any) {

    try {
        const { data } = yield call(I130CasesAPI.i130AFormPdfData, request);

        yield put({
            type: SAVEPDF_I130AFORMS_SUCCESS,
            payload: data

        });
    } catch (e) {
        yield put({ type: SAVEPDF_I130AFORMS_FAILED, payload: e.message });
    }
}


export function* i131formsCreate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i131formsCreate, request.input);
        yield put({
            type: SAVE_I131FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I131FORMS_FAILED, payload: e.message });
    }
}

export function* i131formsUpdate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i131formsUpdate, request.input);
        yield put({
            type: UPDATE_I131FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I131FORMS_FAILED, payload: e.message });
    }
}

export function* getI131formsDetails(request: any) {
    try {

        const { data } = yield call(I130CasesAPI.getI131formsDetails, request);

        yield put({
            type: GET_I131FORMS_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_I131FORMS_FAILED, payload: e.message });
    }
}

export function* i131FormPdfData(request: any) {

    try {
        const { data } = yield call(I130CasesAPI.i131FormPdfData, request);

        yield put({
            type: SAVEPDF_I131FORMS_SUCCESS,
            payload: data

        });
    } catch (e) {
        yield put({ type: SAVEPDF_I131FORMS_FAILED, payload: e.message });
    }
}

export function* i864formsCreate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i864formsCreate, request.input);
        yield put({
            type: SAVE_I864FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I864FORMS_FAILED, payload: e.message });
    }
}
export function* i864formsUpdate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i864formsUpdate, request.input);
        yield put({
            type: UPDATE_I864FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I864FORMS_FAILED, payload: e.message });
    }
}

export function* getI864formsDetails(request: any) {
    try {

        const { data } = yield call(I130CasesAPI.getI864formsDetails, request);

        yield put({
            type: GET_I864FORMS_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_I864FORMS_FAILED, payload: e.message });
    }
}

export function* i864FormPdfData(request: any) {

    try {
        const { data } = yield call(I130CasesAPI.i864FormPdfData, request);

        yield put({
            type: SAVEPDF_I864FORMS_SUCCESS,
            payload: data

        });
    } catch (e) {
        yield put({ type: SAVEPDF_I864FORMS_FAILED, payload: e.message });
    }
}

export function* i485formsCreate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i485formsCreate, request.input);
        yield put({
            type: SAVE_I485FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_I485FORMS_FAILED, payload: e.message });
    }
}
export function* i485formsUpdate(request: any) {

    try {
        const result = yield call(I130CasesAPI.i485formsUpdate, request.input);
        yield put({
            type: UPDATE_I485FORMS_SUCCESS,
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_I485FORMS_FAILED, payload: e.message });
    }
}

export function* getI485formsDetails(request: any) {
    try {

        const { data } = yield call(I130CasesAPI.getI485formsDetails, request);

        yield put({
            type: GET_I485FORMS_SUCCESS,
            payload: data
        });
    } catch (e) {
        yield put({ type: GET_I485FORMS_FAILED, payload: e.message });
    }
}

export function* i485FormPdfData(request: any) {

    try {
        const { data } = yield call(I130CasesAPI.i485FormPdfData, request);

        yield put({
            type: SAVEPDF_I485FORMS_SUCCESS,
            payload: data

        });
    } catch (e) {
        yield put({ type: SAVEPDF_I485FORMS_FAILED, payload: e.message });
    }
}